import { Switch, useRouteMatch } from 'react-router-dom';
import { EditInviteDrawer } from 'assets/js/pages/account-settings/users/EditInviteDrawer';
import { EditUserDrawer } from 'assets/js/pages/account-settings/users/EditUserDrawer';
import { InviteUserDrawer } from 'assets/js/pages/account-settings/users/InviteUserDrawer';
import { UserSettings } from 'assets/js/pages/account-settings/users/UserSettings';
import { UserSettingsV2 } from 'assets/js/pages/account-settings/users/UserSettingsV2';
import { ViewRoleDrawer } from 'assets/js/pages/account-settings/users/ViewRoleDrawer';
import { DrawerRoute } from 'components/drawer-route';
import { Route } from 'components/router/Route';
import { useFlags } from 'launchdarkly-react-client-sdk';

const AccountMembersRouter = () => {
    const { accountRolesPermissions } = useFlags();
    const match = useRouteMatch();

    return (
        <>
            <DrawerRoute
                path={`${match.path}/roles/:roleId/view`}
                exact
                component={ViewRoleDrawer}
            />
            <DrawerRoute path={`${match.path}/invite`} exact component={InviteUserDrawer} />
            <DrawerRoute
                path={`${match.path}/invites/:inviteId/edit`}
                exact
                component={EditInviteDrawer}
            />
            <DrawerRoute path={`${match.path}/:memberId/edit`} exact component={EditUserDrawer} />
            <Switch>
                <Route
                    path={match.path}
                    component={accountRolesPermissions ? UserSettingsV2 : UserSettings}
                />
            </Switch>
        </>
    );
};

export { AccountMembersRouter };
